import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export async function GetAuthenticatedSession({
    clientSdk,
}: DependenciesPayload): Promise<unknown> {
    try {
        return await clientSdk.user.getAuthenticatedSession();
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
